import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FilterInput from "components/search_sidebar/filter_input";

import SelectFile from './select_file';
import FilePanel from './file_panel';

import { updateImport, saveImport, cancelImport } from '../store/actions/import_object';

export class UploadFile extends React.Component {
  static propTypes = {
    importObject: PropTypes.object.isRequired,
    standardTemplatePath: PropTypes.string.isRequired,
    onCancelImport: PropTypes.func.isRequired,
    onSaveImport: PropTypes.func.isRequired,
    onUpdateImport: PropTypes.func.isRequired
  }

  isButtonDisabled = () => {
    const { importObject: { files } } = this.props;

    const values = Object.values(files);

    return values.every(file => file.mapperType == "Do Not Import" || file.mapperType == null)
      || values.length === 0;
  }

  handleNameChange = (e) => {
    const { importObject, onUpdateImport } = this.props;
    importObject.name = e.target.value;
    onUpdateImport(importObject);
  }

  renderNameField() {
    const { importObject: { name } } = this.props;
    return (
      <div className="mv-5 mh-5">
        <FilterInput
          label="Import Name"
          value={name}
          onChange={this.handleNameChange}
        />
      </div>
    );
  }

  renderButtons() {
    const { onCancelImport, onSaveImport } = this.props;

    return (
      <div className="pull-left">
        <div
          className="btn btn-cancel btn-md"
          onClick={onCancelImport}
        >
          Cancel
        </div>

        <div
          className="btn btn-save btn-md ml-4"
          disabled={this.isButtonDisabled()}
          onClick={onSaveImport}
        >
          Save & Continue
        </div>
      </div>
    );
  }

  renderStandardTemplatePrompt() {
    const { standardTemplatePath } = this.props;

    return (
      <div className="container prompt-container download-file">
        <div className="pb-4">
          <h3 className="step-title h3 mt-0">Accepted Format</h3>
          <p>
            To import your data, you must format your data to match the Buildout Standard Format.
            Download this sample spreadsheet to make sure all your columns match the Buildout Standard Format.
            Check out the Knowledge Base for more information about how to get your data to match
            the Buildout Standard Format.
          </p>
          <a download href={standardTemplatePath}>
            Download Buildout Standard Template
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { importObject: { files } } = this.props;
    return (
      <React.Fragment>
        {this.renderStandardTemplatePrompt()}
        <div className="container step-container upload-file">
          <div className="panel panel-default">
            {this.renderNameField()}
            {Object.keys(files).length > 0 && <FilePanel />}
            <SelectFile />
          </div>
          {this.renderButtons()}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  importObject: state.importObject,
  standardTemplatePath: state.paths.standardTemplatePath
});

const mapDispatchToProps = {
  onCancelImport: cancelImport,
  onSaveImport: saveImport,
  onUpdateImport: updateImport
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
